import { Box, Flex, Icon, Radio, RadioGroup, Stack } from "@chakra-ui/react"
import TurboBadge from "@components/Product/TurboBadge"
import { OfferData } from "@type/product"
import { addBusinessDays, formatDate } from "@utils/date"
import { Dispatch, SetStateAction } from "react"
import { GiTortoise } from "react-icons/gi"

const ProductOffers = ({
  offers,
  selectedOffer,
  setOffer,
  regularOffset,
  fastOffset,
  listPrice,
}: {
  offers: OfferData[]
  selectedOffer: number
  setOffer: Dispatch<SetStateAction<number>>
  regularOffset: number | null | undefined
  fastOffset: number | null | undefined
  listPrice?: number
}) => {
  return (
    <Box w={"full"}>
      <RadioGroup
        onChange={(value) => setOffer(Number(value))}
        value={String(selectedOffer)}
      >
        <Stack direction={"column"}>
          {offers?.map((offer, index) => {
            const offset = index === 0 ? fastOffset || 0 : regularOffset || 0

            const deliveryMin = formatDate(
              addBusinessDays({
                numDays: offer.deliveryLeadTime.minValue + offset,
              }),
              { day: "numeric", month: "short" }
            )
            const deliveryMax = formatDate(
              addBusinessDays({
                numDays: offer.deliveryLeadTime.maxValue + offset,
              }),
              { day: "numeric", month: "short" }
            )

            const savings = offer?.identifier?.value
            const savingsAED =
              index === 1 &&
              ((offer.price - offers[0].price) * -1).toLocaleString("en-AE", {
                style: "currency",
                currency: "AED",
              })

            return (
              <Radio
                key={index}
                value={String(index)}
                alignItems={"center"}
                colorScheme={"yellow"}
              >
                <Flex
                  justifyContent={"space-between"}
                  fontWeight={selectedOffer === index ? 500 : 400}
                  padding={2}
                  borderRadius={6}
                  shadow={selectedOffer === index ? "md" : "none"}
                >
                  <Box>
                    <Box>
                      {index === 0 ? (
                        offer.deliveryLeadTime.maxValue <= 3 ? (
                          <TurboBadge />
                        ) : (
                          "Regular"
                        )
                      ) : (
                        <Flex
                          justifyContent={"flex-start"}
                          alignItems={"center"}
                        >
                          <Box as={"span"}>{"Wait and Save"}</Box>
                          <Icon
                            ms={1}
                            as={GiTortoise}
                            color={
                              selectedOffer === index ? "green.500" : "black"
                            }
                            w={6}
                            h={6}
                          />
                        </Flex>
                      )}
                    </Box>
                    <Box fontSize={"xs"}>
                      {"Free Delivery "}
                      {deliveryMin}
                      {" - "}
                      {deliveryMax}
                    </Box>
                  </Box>
                  <Box fontWeight={selectedOffer === index ? 700 : 400}>
                    {index === 0 ? (
                      <Flex
                        alignItems={"flex-end"}
                        flexDirection={"column"}
                        fontSize={"sm"}
                      >
                        <Box>
                          {offers[index].price.toLocaleString("en-AE", {
                            style: "currency",
                            currency: "AED",
                          })}
                        </Box>
                        {savings && listPrice && (
                          <>
                            <Box
                              fontWeight={400}
                              fontSize={"xs"}
                            >
                              <Box
                                as={"span"}
                                textDecoration={"none"}
                              >
                                {"Was:"}{" "}
                              </Box>
                              <Box
                                as={"span"}
                                textDecoration={"line-through"}
                              >
                                {listPrice.toLocaleString("en-AE", {
                                  style: "currency",
                                  currency: "AED",
                                })}
                              </Box>
                            </Box>
                            <Box
                              color={"red.600"}
                              fontSize={"lg"}
                            >
                              {`${savings}% OFF`}
                            </Box>
                          </>
                        )}
                      </Flex>
                    ) : (
                      <Flex
                        alignItems={"flex-end"}
                        flexDirection={"column"}
                        fontSize={"sm"}
                      >
                        <Box>
                          {offers[1].price.toLocaleString("en-AE", {
                            style: "currency",
                            currency: "AED",
                          })}
                        </Box>
                        {savings && listPrice ? (
                          <>
                            <Box
                              fontWeight={400}
                              fontSize={"xs"}
                            >
                              <Box
                                as={"span"}
                                textDecoration={"none"}
                              >
                                {"Was:"}{" "}
                              </Box>
                              <Box
                                as={"span"}
                                textDecoration={"line-through"}
                              >
                                {listPrice.toLocaleString("en-AE", {
                                  style: "currency",
                                  currency: "AED",
                                })}
                              </Box>
                            </Box>
                            <Box
                              color={"red.600"}
                              fontSize={"lg"}
                            >
                              {`${savings}% OFF`}
                            </Box>
                          </>
                        ) : (
                          <>
                            <Box
                              textDecoration={"line-through"}
                              fontSize={"xs"}
                            >
                              {offers[0].price.toLocaleString("en-AE", {
                                style: "currency",
                                currency: "AED",
                              })}
                            </Box>
                            <Box
                              color={"red.500"}
                              fontSize={"lg"}
                            >
                              {"Save "}
                              {savingsAED}
                            </Box>
                          </>
                        )}
                      </Flex>
                    )}
                  </Box>
                </Flex>
              </Radio>
            )
          })}
        </Stack>
      </RadioGroup>
    </Box>
  )
}

export default ProductOffers
